
import { RevContainer } from '@ds/components/Container'
import { RevSkeleton } from '@ds/components/Skeleton'

export default {
  components: {
    RevSkeleton,
    RevContainer,
  },
}
